// eslint-disable-next-line import/prefer-default-export
export const GENERAL = {
  libelleSociete: 'Société :',
  libelleAgences: 'Agences :',
  workInProgress: 'Fonctionnalité en cours de développement',
  emailFormatError: 'Le format de l’email saisi est incorrect',
  urlFormatError: 'Le format de l’url saisie est incorrect.',
  deconnexion: 'Déconnexion',
  DeleteParam: 'Supprimer le cache',
  downloadAnyDesk: 'Téléchargement AnyDesk',
  account: 'Mon compte',
  multiAgence: 'Multi-agences',
  impossibleChangementAgenceSociete: 'Le changement de société/agence n\'est pas possible sur cet écran',
  parametrage: 'Paramétrage',
  configClient: 'Configuration du site',
  import: 'Importer des données',
  export: 'Exporter des données',
  configInterne: 'Configuration interne',
  problemOccurred: 'Un problème est survenu',
  noAccess: 'Vos droits d\'accès ne vous autorisent pas à consulter cette page.',
  dontUseCropper: 'Je souhaite conserver mon image et ne pas modifier le format',
  conserveAnciennePj: 'Je souhaite conserver la photo précédente dans les pièces jointes',
  info: 'Informations',
  new: 'Nouveautés',
  lastModificationBy: 'Modifié par {user}, le {date}.',
  creatednBy: 'Ajouté par {user}, le {date}.',
  enCoursCalcul: 'En cours de calcul',
  oui: 'Oui',
  non: 'Non',
  divers: 'Divers',
  changeUser: 'Changer d\'utilisateur',
  mm: 'mm',
  popUpChangeUser: {
    title: 'Changer d\'utilisateur',
    selectUser: 'Sélectionner un utilisateur',
    password: 'Mot de passe',
  },
  quantity: {
    day: 'Jour',
    week: 'Semaine',
    month: 'Mois',
    year: 'Année',
    unity: 'Unite',
    percent: 'Pourcentage',
    metreCarre: 'Mètre carré',
    face: 'Face',
    encart: 'Encart',
    parution: 'Parution',
    initialPercent: '%',
    initialMetreCarre: 'M²',
    initialFace: 'F',
    initialDay: 'J',
    initialWeek: 'S',
    initialMonth: 'M',
    initialYear: 'A',
    initialUnity: 'U',
    initialEncart: 'E',
    initialParution: 'P',
  },
  quantityLight: {
    day: 'Jour(s)',
    week: 'Semaine(s)',
    month: 'Mois',
    year: 'An(s)',
    unity: 'Unité(s)',
    percent: '%',
    metreCarre: 'M²',
    face: 'Face(s)',
    encart: 'Encart(s)',
    parution: 'Parution(s)',
  },
  discountType: {
    money: '€',
    pourcentage: '%',
    pourcentageMajoration: '%+',
    pourcentageRemise: '%-',
    montantMajoration: '€+',
    montantRemise: '€-',
    custom: 'Personnalisée',
    initialCustom: 'P',
  },
  discountTypeLigne: {
    accrued: 'Cumulée',
    cascade: 'Cascade',
    sousTotal: 'Sous total',
  },
  button: {
    ok: 'OK',
    cancel: 'Annuler',
    delete: 'Supprimer',
    dupliquer: 'Dupliquer',
    edit: 'Modifier',
    new: 'Créer',
    generate: 'Générer',
    next: 'Continuer',
    add: 'Ajouter',
    search: 'Rechercher',
    return: 'Retour',
    send: 'Envoyer',
    apply: 'Appliquer',
    sauvegarder: 'Sauvegarder',
    export: 'Exporter',
    import: 'Importer',
    edition: 'Editer',
    close: 'Fermer',
    archiver: 'Archiver',
    desarchiver: 'Désarchiver',
    reinitialiser: 'Réinitialiser',
    appliquer: 'Appliquer',
    filtre: 'Filtre',
    fusion: 'Fusionner',
    valider: 'Valider',
    annuler: 'Annuler',
    brief: 'Mon brief',
    panier: 'Panier',
    appliquerBrief: 'Appliquer les paramètres de votre brief',
    appliquerRecherche: 'Appliquer les paramètres de votre recherche',
    terminer: 'Terminer',
    selection: 'Sélection',
    maRecherche: 'Ma recherche',
    suivant: 'Suivant',
    precedent: 'Précédent',
    save: 'Enregistrer',
    download: 'Télécharger',
    afficher: 'Vue schéma',
    dupliquerSelection: 'Dupliquer la séléction',
    prevenir: 'Prévenir',
  },
  placeHolder: {
    groupedAction: 'Actions groupées',
    search: 'Rechercher',
  },
  autocomplete: {
    noRslt: 'Aucun résultat',
    search: 'Recherche...',
    advancedSearch: 'Recherche avancée',
  },
  permission: {
    unAuthorized: 'Vous ne disposez pas des autorisations nécessaires',
    contactAdmin: 'Vos droits ne vous permettent pas d’utiliser cette fonctionnalité, veuillez vous rapprocher du collaborateur en charge du paramétrage d’Affixe2.0.',
    close: 'Fermer',
  },
  popUpEdition: {
    title: 'Edition',
    actions: {
      cancel: 'Annuler',
      valider: 'Valider',
      editionExtraitCompteTiers: 'Grand livre',
    },
    type: {
      pdf: 'PDF',
      docx: 'DOCX',
      other: 'Autre...',
    },
  },
  popUpChangementCommercial: {
    title: 'Changement de commercial',
    messageConfirmation: 'Voulez-vous vraiment appliquer ces changements ?',
    actions: {
      cancel: 'Annuler',
      valider: 'Appliquer',
    },
    informations: {
      aucunCommercial: 'Aucun(e) commercial(e) sélectionné(e)',
      trade: 'Commercial(e)',
    },
    errors: {
      modullePresseActif: 'Le module presse ne doit pas être activé',
      aucunCommercial: 'Aucun commercial sélectionné',
      commercialNotExist: 'Le commercial sélectionné n\'existe pas',
    },
    success: 'Changement commercial effectué avec succès',
  },
  breadcrumb: {
    racine: 'Accueil',
    parametrage: 'Paramétrage',
  },
  filtre: {
    title: 'Filtre',
    sousTitle: 'Les filtres seront appliqués à la liste',
  },
  brief: {
    title: 'Mon brief',
    appliquerBrief: 'Appliquer les paramètres de votre brief',
  },
  panier: {
    panier: 'Panier',
    sousTitle: '{numberProduit} produits dans votre panier',
    panierVide: 'Votre panier est vide',
    total: 'Total',
    newSelection: 'Nouvelle sélection',
    clearSelection: 'Vider ma sélection',
    noProduct: 'Sélectionnez des produits',
    noNewProduct: 'Aucun produit ajouté via l\'écran de sélection',
    produitFromDCF: 'Produit(s) présent(s) dans {typeDCF}',
    type: {
      devis: 'le devis',
      commande: 'la commande',
      facture: 'la facture',
    },
  },
  select: {
    title: 'Ma sélection',
    selectVide: 'Votre sélection est vide',
    noProduit: 'Sélectionnez des produits',
    newSelection: 'Nouvelle sélection',
    clearSelection: 'Vider ma sélection',
    sousTitle: '{numberProduit} produits dans votre sélection',
  },
  popUpSuppresionPjImage: {
    title: {
      image: 'Etes-vous sûr de vouloir supprimer votre image ?',
      pj: 'Etes-vous sûr de vouloir supprimer votre pièce-jointe ?',
    },
    sousTitle: {
      edition: 'La suppression sera prise en compte à la sauvegarde',
      detail: 'La suppression sera prise en compte immédiatement',
    },
  },
  popUpResizeImg: {
    title: 'Redimensionner votre image',
    preview: 'Prévisualisation',
  },
  sens: {
    achat: 'Achat',
    vente: 'Vente',
  },
  messages: {
    success: {
      copyLink: 'Lien copié avec succès.',
    },
    error: {
      excelError: 'Problème lors de la génération du fichier excel',
      untranslateError: 'Un problème est survenu',
      emptySelection: 'Aucun élément selectionné',
      violatesForeignKey: 'Impossible de supprimer cet élément car il est lié à des {table}',
      violatesForeignKeyNoTranslate: 'Impossible de supprimer cet élément car il est utilisé dans l\'application',
      addPieceJointeLengthError: 'Les URLs des pièces jointes doivent comporter un maximum de 1024 caractères.',
      getPieceJointeLengthError: 'Certaine(s) pièce(s) jointe(s) ont une URL de plus de 1024 caractères. Veuillez contacter le support pour plus d\'informations.',
      messageErrorCleApiEdition: 'Votre clé API Google est invalide.',
      noEdition: 'Aucun élément trouvé',
      entityNotFound: 'Aucun(e) {entity} trouvé(e)',
    },
    warning: {
      archive: 'Élément archivé',
    },
  },
  au: 'au',
  du: 'Du',
  et: 'et',
  a: 'à',
  signataire: {
    ajout: {
      contactPrincipal: 'Contact principal',
      signataireRelance: 'Signataire pour les relances',
      fonctionSignataireRelance: 'Fonction du signataire pour les relances',
      emailSignataireRelance: 'Email du signataire pour les relances',
      signataireBaux: 'Signataire pour les baux',
      fonctionSignataireBaux: 'Fonction du signataire pour les baux',
      signataireRecouvrement: 'Signataire recouvrement',
      telephoneRecouvrement: 'Téléphone recouvrement',
    },
    detail: {
      contactPrincipal: 'Contact principal :',
      signataireRelance: 'Signataire pour les relances :',
      fonctionSignataireRelance: 'Fonction du signataire pour les relances :',
      emailSignataireRelance: 'Email du signataire pour les relances :',
      signataireBaux: 'Signataire pour les baux :',
      fonctionSignataireBaux: 'Fonction du signataire pour les baux :',
      signataireRecouvrement: 'Signataire recouvrement :',
      telephoneRecouvrement: 'Téléphone recouvrement : ',
    },
  },
  warning: 'Attention',
  datePeriode: 'Du {dateDebut} au {dateFin}',
  inconnu: 'Inconnu',
  chargement: 'Chargement en cours...',
  detailLogo: {
    breadcrumb: 'Détail logo',
    title: 'Détail logo',
  },
  noActionSelect: 'Aucune action sélectionnée',
  fait: 'Fait',

  suppression: {
    titre: 'Etes-vous sûr de vouloir supprimer {type}?',
    sousTitre: 'Cette action est irréversible.',
  },
  archiver: {
    titre: 'Etes-vous sûr de vouloir archiver {type}?',
    reactive: 'Etes-vous sûr de vouloir desarchiver {type}?',
  },
  parametrageTable: {
    title: 'Paramètre du tableau',
    nbreParPage: 'Eléments par page',
  },
  informationGeneral: 'Informations générales',
  previsualisation: 'Prévisualisation',
  composants: {
    commentaireListInput: {
      tooltipError: 'Une erreur est survenue lors de l\'enregistrement, veuillez réessayer de saisir vote commentaire.',
      tooltipInfo: 'Champs de saisie de commentaire avec sauvegarde automatique',
      popupTitle: 'Mise à jour commentaire',
      popupLibelle: 'Commentaire :',
    },
    codeInseeInput: {
      message: 'Aucun code INSEE trouvé',
      codeInsee: 'Code INSEE',
      departement: 'Département',
      ville: 'Ville',
      messageError: 'Une erreur est survenue lors de la recherche du code INSEE',
    },
    checkboxAsync: {
      tooltipError: 'Une erreur est survenue lors de l\'enregistrement, veuillez réessayer de cocher la case.',
      tooltipInfo: 'Case à cocher avec sauvegarde automatique',
    },
  },
};
